import { useState } from 'react'
import {
  Box,
  Button,
  Container,
  Typography,
  Link as MuiLink,
  Slide,
} from '@mui/material'

const COOKIE_CONSENT_KEY = 'wenw_cookie_consent'

export const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY)
    return !consent
  })

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted')
    setShowBanner(false)
  }

  if (!showBanner) return null

  return (
    <Slide direction="up" in={showBanner} mountOnEnter unmountOnExit>
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
          backgroundImage: 'linear-gradient(90deg, #430397, #fe2f61)',
          boxShadow: '0 -4px 12px rgba(0, 0, 0, 0.3)',
        }}
      >
        <Container maxWidth="xl">
          <Box
            sx={{
              py: { xs: 2.5, sm: 3 },
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: { xs: 'flex-start', md: 'center' },
              gap: { xs: 2, md: 3 },
            }}
          >
            <Typography
              sx={{
                color: '#fff',
                fontSize: { xs: '0.875rem', md: '0.9375rem' },
                lineHeight: 1.6,
                flex: 1,
              }}
            >
              We and our partners use cookies on this site to improve our
              service, perform analytics, personalize advertising, measure
              advertising performance, and remember website preferences. By
              using the site, you consent to these cookies. For more information
              on cookies including how to manage your consent visit our{' '}
              <MuiLink
                href="https://www.nbcuniversalprivacy.com/privacy/cookies"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: '#fff',
                  fontWeight: 600,
                  textDecoration: 'underline',
                  '&:hover': {
                    opacity: 0.8,
                  },
                }}
              >
                cookie policy
              </MuiLink>
              .
            </Typography>
            <Button
              variant="contained"
              onClick={handleAccept}
              sx={{
                backgroundColor: '#fff',
                color: '#430397',
                fontWeight: 600,
                fontSize: { xs: '0.875rem', md: '0.9375rem' },
                px: { xs: 4, md: 5 },
                py: { xs: 1, md: 1.25 },
                borderRadius: '4px',
                textTransform: 'none',
                minWidth: { xs: '100%', md: 'auto' },
                whiteSpace: 'nowrap',
                '&:hover': {
                  backgroundColor: '#f0f0f0',
                },
              }}
            >
              Continue
            </Button>
          </Box>
        </Container>
      </Box>
    </Slide>
  )
}
